import classNames from 'classnames';
import { useEffect, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PATHS } from '../../../app.settings';
import { BreadcrumbsComp } from '../../../Components/BreadcrumbsComp';
import { ButtonBackComp } from '../../../Components/ButtonBackComp';
import { ButtonComp } from '../../../Components/ButtonComp';
import { ButtonDeleteComp } from '../../../Components/ButtonDeleteComp';
import LoadingPageComp from '../../../Components/LoadingPageComp';
import { IContato } from './model';
import { getById, save, remove } from './service';

export default function ContatoForm() {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<IContato>();

  const [loading, setLoading] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [locationState, setLocationState] = useState<any>();

  const loadForm = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (record: Record<string, any>) => {
      const entries = Object.entries(record);
      entries.forEach(([key, value]) => {
        switch (key) {
          default:
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            setValue(key as any, value);
        }
      });
    },
    [setValue],
  );

  const init = useCallback(async () => {
    if (params?.id) {
      setLoading(true);
      getById(params.id)
        .then(loadForm)
        .finally(() => setLoading(false));
    } else {
      // insere campos default
    }
  }, [loadForm, params.id]);

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    setLocationState(location.state);
  }, [location]);

  const navigateToList = async (sleep: number) => {
    await new Promise((t) => setTimeout(t, sleep)).then(() => {
      navigate(PATHS.contato, { state: locationState });
    });
  };

  const submit = (data: IContato) => {
    save(data).then(loadForm);
    navigateToList(1000);
  };

  const del = () => {
    const id = getValues('id').toString();
    if (id) {
      remove(id).then(loadForm);
      navigateToList(1000);
    }
  };

  return (
    <form onSubmit={handleSubmit(submit)} className="divide-y space-y-4">
      <div className="flex items-center justify-between py-3">
        <BreadcrumbsComp
          title={params?.id ? 'Alterar' : 'Inserir'}
          paths={[
            {
              label: 'Tipos de Contatos',
              onClick: () => navigateToList(0),
            },
          ]}
        />
        <div className="flex space-x-2">
          <ButtonBackComp label="Voltar" type="button" onClick={() => navigateToList(0)} />
          {params?.id && (
            <ButtonDeleteComp confirm={true} label="Excluir" type="button" onClick={del} />
          )}
          <ButtonComp label="Salvar" type="submit" />
        </div>
      </div>
      <div>
        {loading ? (
          <LoadingPageComp />
        ) : (
          <div className="max-w-lg space-y-2">
            <label htmlFor="nome" className="flex flex-col">
              <span>Descrição</span>
              <input
                id="nome"
                type="text"
                className="rounded-lg"
                placeholder="Descrição"
                {...register('nome', {
                  required: {
                    value: true,
                    message: '(*) Campo requerido',
                  },
                })}
              />
              {errors?.nome && (
                <span className="text-red-500 text-xs">{errors?.nome?.message}</span>
              )}
            </label>
          </div>
        )}
      </div>
    </form>
  );
}
